import { render } from "./floader_sub.vue?vue&type=template&id=ddb5a5da"
import script from "./floader_sub.vue?vue&type=script&lang=js"
export * from "./floader_sub.vue?vue&type=script&lang=js"

import "./floader_sub.vue?vue&type=style&index=0&id=ddb5a5da&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__